import React, { useEffect, useRef, useState } from "react";
import classes from "./indentdashboard.module.css";
import DashboardRouting from "./DashboardRouting";
import { useHistory, useLocation } from "react-router-dom";
// import DashboardDropdown from "./IndentRequestDashboard/DashboardDropdown";
import Loader from "../../Loader";
import { useIndentTracking } from "../hooks/useIndentTracking";
import useViewOnlyAccess from "../../../hooks/useViewOnlyAccess";

const Indentdashboard = () => {
  const [selectedTab, setSelectedTab] = useState("request");
  const [show, setShow] = useState(false);
  const history = useHistory();
  const location = useLocation();
  const { trackIndentEvent } = useIndentTracking();
  const redirectedRef = useRef(false); // Guard: only redirect once on mount

  const { dashboardAccess: reqDashboardAccess, loading: reqLoading } = useViewOnlyAccess('indent', 'lorri_indent_request', true);
  const { dashboardAccess: trackDashboardAccess, loading: trackLoading } = useViewOnlyAccess('indent', 'lorri_indent_tracking', true);
  const { dashboardAccess: transitDashboardAccess, loading: transitLoading } = useViewOnlyAccess('indent', 'lorri_indent_tracking', true);

  const showReqButton = reqDashboardAccess;
  const showTrackButton = trackDashboardAccess;
  const showTransitButton = transitDashboardAccess;

  useEffect(() => {
    trackIndentEvent("indent dashboard", "user has visited indent dashboard");
  }, []);

  useEffect(() => {
    if (location.pathname.includes("/indents/requestdashboard")) {
      setSelectedTab("request");
    } else if (location.pathname.includes("/indents/trackingdashboard")) {
      setSelectedTab("tracking");
    } else if (location.pathname.includes("/indents/transittimedashboard")) {
      setSelectedTab("transit");
    }
  }, [location.pathname]);

  useEffect(() => {
    if (reqLoading || trackLoading || transitLoading) return;
    if (redirectedRef.current) return;
    redirectedRef.current = true;

    const onRequestDashboard = location.pathname.includes("/indents/requestdashboard");
    const onTrackingDashboard = location.pathname.includes("/indents/trackingdashboard");
    const onTransitDashboard = location.pathname.includes("/indents/transittimedashboard");

    if (onRequestDashboard && !reqDashboardAccess) {
      if (trackDashboardAccess) {
        history.replace({ pathname: "/indents/trackingdashboard" });
      } else if (transitDashboardAccess) {
        history.replace({ pathname: "/indents/transittimedashboard" });
      }
    } else if (onTrackingDashboard && !trackDashboardAccess) {
      if (reqDashboardAccess) {
        history.replace({ pathname: "/indents/requestdashboard" });
      } else if (transitDashboardAccess) {
        history.replace({ pathname: "/indents/transittimedashboard" });
      }
    } else if (onTransitDashboard && !transitDashboardAccess) {
      if (reqDashboardAccess) {
        history.replace({ pathname: "/indents/requestdashboard" });
      } else if (trackDashboardAccess) {
        history.replace({ pathname: "/indents/trackingdashboard" });
      }
    }
  }, [reqLoading, trackLoading, transitLoading, reqDashboardAccess, trackDashboardAccess, transitDashboardAccess]);

  const handleToggle = (type) => {
    setSelectedTab(type);
    if (type === "request") {
      history.push({ pathname: "/indents/requestdashboard" });
      trackIndentEvent(
        "indent dashboard",
        "user has clicked on indent request dashboard"
      );
    } else if (type === "tracking") {
      history.push({ pathname: "/indents/trackingdashboard" });
      trackIndentEvent(
        "indent dashboard",
        "user has clicked on indent tracking dashboard"
      );
    } else {
      history.push({ pathname: "/indents/transittimedashboard" });
      trackIndentEvent(
        "indent dashboard",
        "user has clicked on transit time summary dashboard"
      );
    }
  };

  return (
    <>
      <Loader show={show} />
      <div className={classes["sidebarLayout"]}>
        <div className={classes["sidebarNav"]}>
          {showReqButton && (
            <button
              type="button"
              className={`${classes["sidebarNavItem"]} ${selectedTab === "request" ? classes["sidebarNavItemActive"] : ""}`}
              onClick={() => handleToggle("request")}
            >
              Indent Request
            </button>
          )}
          {showTrackButton && (
            <button
              type="button"
              className={`${classes["sidebarNavItem"]} ${selectedTab === "tracking" ? classes["sidebarNavItemActive"] : ""}`}
              onClick={() => handleToggle("tracking")}
            >
              Vehicle Status
            </button>
          )}
          {showTransitButton && (
            <button
              type="button"
              className={`${classes["sidebarNavItem"]} ${selectedTab === "transit" ? classes["sidebarNavItemActive"] : ""}`}
              onClick={() => handleToggle("transit")}
            >
              Transit Time Summary
            </button>
          )}
        </div>
        <div className={`${classes["sidebarContent"]} ${classes["indentFilterBarWrap"]}`}>
          <DashboardRouting />
        </div>
      </div>
    </>
  );
};

export default Indentdashboard;
